import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { showDate } from '../../constant';
import tick from "../../Assets/tick-svgrepo-com.svg"

const ViewRole = () => {
  let location = useLocation();
  let navigate = useNavigate();
  let data = location.state
  const [permissions] = useState(data?.permissions ||
  {
    student: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
    enrollment: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
    master: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
    system: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
    expense: {
      create: false,
      read: false,
      update: false,
      delete: false
    },
  }
  )

  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
        <div className="xl:flex xl:items-center xl:justify-between">
          <h1 className="hidden text-2xl font-semibold text-primary-600 lg:block">
            Role Details
          </h1>
          <button type="button" className="btn btn-light" onClick={() => navigate('/dashboard/role/')}>
            Back
          </button>
        </div>

        <div className="mt-8 md:mt-6 sm:flex sm:items-center sm:space-x-6">
          <div className="flex items-center space-x-3">
            <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
              <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
              <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
            </svg>
            <span className="text-gray-600">
              Role Id
            </span>
          </div>

          <div className="flex items-center mt-3 space-x-3 sm:mt-0">
            <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
              <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
              <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
            </svg>
            <span className="text-gray-600">
              Created - {<span>{showDate(data.created_at)}</span>}
            </span>
          </div>

          <div className="flex items-center mt-3 space-x-3 sm:mt-0">
            <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
              <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
              <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
            </svg>
            <span className="text-gray-600">
              Updated - {<span>{showDate(data.updated_at)}</span>}
            </span>
          </div>

          <div className="flex items-center mt-3 space-x-3 sm:mt-0">
            <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
              <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
              <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
              <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
            </svg>
            <span className="text-gray-600">
              Deleted - {<span>{showDate(data.deleted_at)}</span>}
            </span>
          </div>
        </div>
        <div className="mt-2 space-y-6">
          <div className="overflow-hidden bg-white rounded-lg shadow">
            <div className="px-4 py-5 sm:p-6">
              <div className="grid xl:grid-cols-6 gap-y-10">
                <div className="xl:col-span-6 xl:pr-8 order-1 lg:order-1 md:order-2 sm:order-2 xs:order-2">
                  <div className="space-y-6">
                    <div>
                      <div className="flex items-center">
                        <p className="font-medium">
                          Role Details
                        </p>
                      </div>

                      <div className="mt-3 space-y-3">
                        <div className="bg-white border border-gray-100 rounded-lg shadow-md">
                          <div className="px-4 py-5 sm:p-6">
                            <div>
                              <div className='flex justify-between'>
                                <div>
                                  <p className="text-md text-gray-600">
                                    Role Type
                                  </p>
                                  <p className="mt-1 text-lg leading-tight text-primary-600">
                                    {data.type}
                                  </p>
                                </div>

                                <div>
                                  <p className="text-md text-gray-600">
                                    Status
                                  </p>

                                  <div className='mt-3'>
                                    {data.is_active ?
                                      (<span className='px-4 py-3 bg-green-500 rounded-md text-white text-center'>Active</span>)
                                      :
                                      (<span className='px-2 py-3 bg-red-500 rounded-md text-white text-center'>Deactive</span>)
                                    }
                                  </div>
                                </div>
                              </div>

                              <div className='mt-8'>
                                <p className="text-md text-gray-600">
                                  Role Permisssion
                                </p>

                                <div className="flex flex-col mt-4">
                                  <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                      <div className="overflow-hidden">
                                        <table className="custom-table">
                                          <thead>
                                            <tr>
                                              <th scope="col">
                                                Category
                                              </th>
                                              <th scope="col" className="hidden sm:table-cell">
                                                Add
                                              </th>
                                              <th scope="col" className="hidden sm:table-cell">
                                                View
                                              </th>
                                              <th scope="col" className="hidden sm:table-cell">
                                                Edit
                                              </th>
                                              <th scope="col" className="hidden sm:table-cell">
                                                Delete
                                              </th>
                                              <th scope="col" className="hidden sm:table-cell">
                                                Select All
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {/* student */}
                                            <tr>
                                              <td>
                                                <div className="flex items-center">
                                                  <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                                    <span className="font-medium leading-none text-white">IN</span>
                                                  </div>
                                                  <div className="flex-1 min-w-0 ml-2">
                                                    <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                                      Students
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>
                                              {/* create */}
                                              <td className="hidden lg:table-cell whitespace-nowrap">
                                                <input type="checkbox" checked={permissions.student.create} />
                                              </td>
                                              {/* read */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.student.read} />
                                              </td>
                                              {/* Edit / Update */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.student.update} />
                                              </td>
                                              {/* delete */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.student.delete} />
                                              </td>
                                              {/* select all */}
                                              <td className="hidden lg:table-cell">
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    permissions.student.create &&
                                                    permissions.student.read &&
                                                    permissions.student.update &&
                                                    permissions.student.delete
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            {/* Enrollment */}
                                            <tr>
                                              <td>
                                                <div className="flex items-center">
                                                  <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                                    <span className="font-medium leading-none text-white">IN</span>
                                                  </div>
                                                  <div className="flex-1 min-w-0 ml-2">
                                                    <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                                      Enrollments
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>
                                              {/* create */}
                                              <td className="hidden lg:table-cell whitespace-nowrap">
                                                <input type="checkbox" checked={permissions.enrollment.create} />
                                              </td>
                                              {/* read */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.enrollment.read} />
                                              </td>
                                              {/* Edit / Update */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.enrollment.update} />
                                              </td>
                                              {/* delete */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.enrollment.delete} />
                                              </td>
                                              {/* select all */}
                                              <td className="hidden lg:table-cell">
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    permissions.enrollment.create &&
                                                    permissions.enrollment.read &&
                                                    permissions.enrollment.update &&
                                                    permissions.enrollment.delete
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            {/* MASTER */}
                                            <tr>
                                              <td>
                                                <div className="flex items-center">
                                                  <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                                    <span className="font-medium leading-none text-white">IN</span>
                                                  </div>
                                                  <div className="flex-1 min-w-0 ml-2">
                                                    <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                                      Master
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>
                                              {/* create */}
                                              <td className="hidden lg:table-cell whitespace-nowrap">
                                                <input type="checkbox" checked={permissions.master.create} />
                                              </td>
                                              {/* read */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.master.read} />
                                              </td>
                                              {/* Edit / Update */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.master.update} />
                                              </td>
                                              {/* delete */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.master.delete} />
                                              </td>
                                              {/* select all */}
                                              <td className="hidden lg:table-cell">
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    permissions.master.create &&
                                                    permissions.master.read &&
                                                    permissions.master.update &&
                                                    permissions.master.delete
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            {/* System */}
                                            <tr>
                                              <td>
                                                <div className="flex items-center">
                                                  <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                                    <span className="font-medium leading-none text-white">IN</span>
                                                  </div>
                                                  <div className="flex-1 min-w-0 ml-2">
                                                    <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                                      System
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>
                                              {/* create */}
                                              <td className="hidden lg:table-cell whitespace-nowrap">
                                                <input type="checkbox" checked={permissions.system.create} />
                                              </td>
                                              {/* read  */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.system.read} />
                                              </td>
                                              {/* Edit / Update */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.system.update} />
                                              </td>
                                              {/* delete / Deletef */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.system.delete} />
                                              </td>
                                              {/* selecte all */}
                                              <td className="hidden lg:table-cell">
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    permissions.system.create &&
                                                    permissions.system.read &&
                                                    permissions.system.update &&
                                                    permissions.system.delete
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            {/* Expenses */}
                                            <tr>
                                              <td>
                                                <div className="flex items-center">
                                                  <div title="" className="inline-flex items-center justify-center flex-shrink-0 w-10 h-10 bg-gray-500 rounded-full">
                                                    <span className="font-medium leading-none text-white">IN</span>
                                                  </div>
                                                  <div className="flex-1 min-w-0 ml-2">
                                                    <div title="" className="font-medium truncate hover:text-primary-600 w-36 sm:w-auto line-clamp-1">
                                                      Expenses
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>
                                              {/* create */}
                                              <td className="hidden lg:table-cell whitespace-nowrap">
                                                <input type="checkbox" checked={permissions.expense.create} />
                                              </td>
                                              {/* read */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.expense.read} />
                                              </td>
                                              {/* Edit / Update */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.expense.update} />
                                              </td>
                                              {/* delete */}
                                              <td className="hidden lg:table-cell">
                                                <input type="checkbox" checked={permissions.expense.delete} />
                                              </td>
                                              {/* select all */}
                                              <td className="hidden lg:table-cell">
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    permissions.expense.create &&
                                                    permissions.expense.read &&
                                                    permissions.expense.update &&
                                                    permissions.expense.delete
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ViewRole
